import React, { FC } from "react";

import { TypeFiesta, TypeInsignia } from "@at/design-system-foundation";
import { Accordion } from "@at/design-system-patterns";
import { getChannelSingular } from "@at/formatter-utils";
import { Channel } from "@at/sauron-platform-core";

import * as Styled from "./charging.styles";
import {
  HowLongDoesItTake,
  HowMuchDoesItCost,
} from "./public-charging-expander-info";
import { useChannel } from "../../../utils/hooks/use-channel";
import { useTracking } from "../../../utils/tracking/use-tracking";

export const PublicChargingInfo: FC = () => {
  const channel = useChannel();
  const { trackAccordionEvent } = useTracking();
  const channelCopy = channel === Channel.cars ? "cars" : "vehicles";
  const channelSingular = getChannelSingular(channel);
  const howMuchDoesItCostInfo = HowMuchDoesItCost();
  const howLongDoesItTakeInfo = HowLongDoesItTake(channelCopy, channelSingular);

  return (
    <>
      <Styled.ModalBodyStyled>
        <TypeInsignia as="h2" weight="400">
          Public charging explained
        </TypeInsignia>

        <TypeFiesta as="p">
          Public charging points for electric {channelCopy} can be found at
          thousands of locations across the UK and the world. These typically
          include car parks, motorway services, roadside spots and even
          dedicated sites similar to petrol stations.
        </TypeFiesta>
        <Accordion
          items={howMuchDoesItCostInfo}
          trackingCallback={(rowProps) => {
            trackAccordionEvent({
              row: rowProps,
              data: howMuchDoesItCostInfo,
            });
          }}
        />
        <Accordion
          items={howLongDoesItTakeInfo}
          trackingCallback={(rowProps) => {
            trackAccordionEvent({
              row: rowProps,
              data: howLongDoesItTakeInfo,
            });
          }}
        />
      </Styled.ModalBodyStyled>
    </>
  );
};
